module.exports = __webpack_public_path__ + "static/img/3.9b595b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/sp/3.png
// module id = dj2I
// module chunks = 0